import React from 'react';
import { FaPaperPlane, FaInstagram, FaMapMarkerAlt } from 'react-icons/fa';
import SEO from '../Components/SEO';
import { buildBreadcrumbSchema, buildContactPageSchema, PAGE_SEO, SITE_NAME, SOCIAL_LINKS } from '../seoConfig';
import contactBg from '../assets/stand2.webp';
import { useModal } from '../stores/ModalContext';

const Contact = () => {
    const { showModal } = useModal();

    const handleSubmit = (event) => {
        event.preventDefault();
        const formData = new FormData(event.target);
        const name = formData.get('name');
        const message = formData.get('message');
        if (!name || !message) {
            return showModal({
                type: 'error',
                title: 'Campos em Falta',
                message: 'Por favor, preenche o teu nome e a mensagem para que o possamos ajudar.'
            });
        }
        const formattedMessage = encodeURIComponent(`Olá ${SITE_NAME}, o meu nome é ${name}. ${message}`);
        window.open(`${SOCIAL_LINKS.whatsapp}?text=${formattedMessage}`, '_blank');
    };

    return (
        <div className="bg-black min-h-screen text-white overflow-x-hidden">
            <SEO
                title={PAGE_SEO.contact.title}
                description={PAGE_SEO.contact.description}
                path={PAGE_SEO.contact.path}
                structuredData={[buildContactPageSchema(), buildBreadcrumbSchema([
                    { name: 'Início', path: '/' },
                    { name: 'Contactos', path: '/contactos' },
                ])]}
            />

            <section className="relative pt-32 pb-20 px-5 lg:px-12 overflow-hidden">
                <img src={contactBg} alt="" className="absolute inset-0 w-full h-full object-cover opacity-20" />
                <div className="absolute inset-0 bg-gradient-to-b from-black via-black/90 to-black" />
                <div className="ajp-grain absolute inset-0" />

                <div className="relative z-10 max-w-[1500px] mx-auto">
                    <p className="section-tag mb-4">Contacto</p>
                    <h1 className="font-display text-6xl sm:text-8xl text-white tracking-wide leading-none mb-6">
                        FALE<br /><span className="text-gradient">CONNOSCO</span>
                    </h1>
                    <p className="text-white/40 text-base max-w-md">
                        Envia-nos uma mensagem via Instagram ou preenche o formulário abaixo.
                    </p>
                </div>
            </section>

            <section className="max-w-[1500px] mx-auto px-5 lg:px-12 pb-24">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-px bg-white/[0.06]">

                    <div className="lg:col-span-7 ajp-panel-light p-8 sm:p-12">
                        <h2 className="font-display text-3xl text-[#0f0f0f] tracking-widest mb-2">MENSAGEM</h2>
                        <p className="text-[#6b6860] text-sm mb-10">Preenche para iniciar conversa no Instagram.</p>

                        <form onSubmit={handleSubmit} className="space-y-6">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label className="block text-[10px] font-bold uppercase tracking-[0.25em] text-[#6b6860] mb-2">Nome *</label>
                                    <input name="name" required type="text" placeholder="O teu nome" className="form-input-light" />
                                </div>
                                <div>
                                    <label className="block text-[10px] font-bold uppercase tracking-[0.25em] text-[#6b6860] mb-2">Email</label>
                                    <input name="email" type="email" placeholder="email@exemplo.pt" className="form-input-light" />
                                </div>
                            </div>
                            <div>
                                <label className="block text-[10px] font-bold uppercase tracking-[0.25em] text-[#6b6860] mb-2">Mensagem *</label>
                                <textarea name="message" required rows="5" placeholder="Olá, gostaria de saber mais sobre..." className="form-input-light resize-none" />
                            </div>
                            <button type="submit" className="btn-primary group">
                                Enviar via Instagram
                                <FaPaperPlane size={10} className="group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform" />
                            </button>
                        </form>
                    </div>

                    <div className="lg:col-span-5 bg-[#0a0a0a] p-8 sm:p-12 space-y-8">
                        <div>
                            <h3 className="text-[10px] font-bold uppercase tracking-[0.3em] text-white/20 mb-6">Contactos Rápidos</h3>
                            <div className="space-y-6">
                                {[
                                    { icon: FaInstagram, label: 'Instagram', val: '@autojoaopirespt', link: SOCIAL_LINKS.instagram },
                                    { icon: FaInstagram, label: 'Mensagem Direta', val: 'Enviar DM', link: SOCIAL_LINKS.whatsapp },
                                    { icon: FaMapMarkerAlt, label: 'Serviços', val: 'Stand & Oficina', link: null },
                                ].map((c, idx) => (
                                    <div key={idx} className="flex gap-4 items-start">
                                        <div className="w-10 h-10 border border-red/20 flex items-center justify-center text-red shrink-0">
                                            <c.icon size={13} />
                                        </div>
                                        <div>
                                            <p className="text-[9px] font-bold uppercase tracking-[0.25em] text-white/25 mb-1">{c.label}</p>
                                            {c.link ? (
                                                <a href={c.link} target="_blank" rel="noreferrer" className="text-white/70 hover:text-red text-sm font-medium transition-colors">{c.val}</a>
                                            ) : (
                                                <p className="text-white/50 text-sm">{c.val}</p>
                                            )}
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        <div className="border border-white/[0.06] p-6">
                            <p className="text-[9px] font-bold uppercase tracking-[0.25em] text-red mb-3">Serviços</p>
                            <ul className="space-y-2 text-white/35 text-sm">
                                <li>Compra & Venda de Automóveis</li>
                                <li>Mecânica Ligeira & Inspeções</li>
                                <li>Lavagem, Polimentos & Cerâmica</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Contact;
